module.exports = new Promise((resolve,reject) => {
                              const remoteUrl = window.__CONFIG__.REACT_APP_PRICING_REMOTE_URL;
                              const script = document.createElement('script');
                              script.src = remoteUrl;
                              script.onload = () => {
                              const proxy = {
                                  get: (request) => window.pricing.get(request),
                                  init: (arg) => {
                                  try {
                                    return window.pricing.init(arg);
                                  } catch (e) {
                                    console.warn('pricing remote already initialized');
                                  }
                                }
                              };
                              resolve(proxy);
                            };
                            script.onerror = (err) =>{
                              console.log('Failed to load remote script',err);
                              reject(new Error('Unable to load RemoteEntry file for Pricing MFE'));
                            }
                            document.head.appendChild(script);
                      });